import { render } from "./VirementListPage.vue?vue&type=template&id=e1e7ec9c&ts=true"
import script from "./VirementListPage.vue?vue&type=script&lang=ts"
export * from "./VirementListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__